import React from 'react'
import moment from 'moment'
import * as R from 'ramda'
import { t } from 'ttag'

import { Box } from 'components/layout/Box/Box'
import { Form } from 'components/shared/Form/Form'

import {
  DEADLINE_FIELD,
  MESSAGES_FIELD,
  MESSAGE_FIELD,
  RECEIVER_FIELD,
  SENDER_FIELD,
  SUBJECT_FIELD,
} from './model'

import styles from './SendTestsMessageForm.module.scss'

export const SendTestsMessageForm = ({
  control,
  currentStepIndex,
  formState,
  type,
}) => (
  <Form className={styles.form}>
    <Box align="center" className={styles.configuration}>
      <Form.Field
        className={styles.field}
        error={
          formState.errors[
            `${MESSAGES_FIELD}[${currentStepIndex}].${RECEIVER_FIELD}`
          ]?.message
        }
        field="input"
        name={`${MESSAGES_FIELD}[${currentStepIndex}].${RECEIVER_FIELD}`}
        label={t`Receiver`}
        isReadOnly
        isRequired
        {...{ control }}
      />
      <Form.Field
        className={styles.field}
        error={
          formState.errors[
            `${MESSAGES_FIELD}[${currentStepIndex}].${DEADLINE_FIELD}`
          ]?.message
        }
        field="input"
        name={`${MESSAGES_FIELD}[${currentStepIndex}].${DEADLINE_FIELD}`}
        label={t`Deadline`}
        max={moment()
          .add(60, 'days')
          .format(moment.HTML5_FMT.DATE)}
        min={moment().format(moment.HTML5_FMT.DATE)}
        type="date"
        isRequired
        {...{ control }}
      />
    </Box>
    <Form.Field
      error={
        formState.errors[
          `${MESSAGES_FIELD}[${currentStepIndex}].${SENDER_FIELD}`
        ]?.message
      }
      field="input"
      name={`${MESSAGES_FIELD}[${currentStepIndex}].${SENDER_FIELD}`}
      label={t`Sender`}
      isReadOnly
      isRequired
      {...{ control }}
    />
    <Form.Field
      error={
        formState.errors[
          `${MESSAGES_FIELD}[${currentStepIndex}].${SUBJECT_FIELD}`
        ]?.message
      }
      field="input"
      name={`${MESSAGES_FIELD}[${currentStepIndex}].${SUBJECT_FIELD}`}
      label={t`Subject`}
      isReadOnly
      isRequired
      {...{ control }}
    />
    <Form.Field
      error={
        formState.errors[
          `${MESSAGES_FIELD}[${currentStepIndex}].${MESSAGE_FIELD}`
        ]?.message
      }
      fieldClassName={styles.textarea}
      field="textarea"
      name={`${MESSAGES_FIELD}[${currentStepIndex}].${MESSAGE_FIELD}`}
      label={t`Message`}
      isReadOnly
      isRequired
      {...{ control }}
    />
  </Form>
)
